import CloseIcon from "@mui/icons-material/Close";

import { Dialog, DialogContent, DialogTitle, IconButton, Typography, useTheme } from "@mui/material";
import { OrderProducts } from "../orders2/orderCard/OrderProducts";
import type { ECommerceProduct } from "./ECommerceOffers";

interface Props {
  readonly selectedRoute: ECommerceProduct[] | null;
  readonly handleCloseRoute: () => void;
}

export function ECommerceRouteDialog({ selectedRoute, handleCloseRoute }: Props) {
  const routeDialogOpen = !!selectedRoute;
  const route = selectedRoute ?? [];
  const theme = useTheme();
  return (
    <Dialog open={routeDialogOpen} onClose={handleCloseRoute} maxWidth="md" fullWidth>
      <DialogTitle sx={{ m: 0, p: 2, fontWeight: "bold" }}>
        Trasa wycieczki
        <IconButton
          onClick={handleCloseRoute}
          sx={{ position: "absolute", right: 8, top: 8, color: theme.palette.grey[500] }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {route.length > 0 ? (
          (() => {
            return <OrderProducts values={route} />;
          })()
        ) : (
          <Typography variant="body1" color="text.secondary" sx={{ textAlign: "center", py: 3 }}>
            Brak szczegółów trasy dla tej wycieczki.
          </Typography>
        )}
      </DialogContent>
    </Dialog>
  );
}
